import React, { forwardRef, useContext } from 'react';

import { Grid as AntGrid, Row } from 'antd';

import { MyTableContext } from '..';

interface IProps {
  onDoubleClick?: any;
  onClick?: any;
  hover?: any;
  style?: any;
  className?: any;
  responsive?: boolean;
  children?: React.ReactNode;
}

const MyTableRow = forwardRef<any, IProps>(({ className, onDoubleClick, onClick, children }, ref) => {
  const { responsive } = useContext(MyTableContext);
  const screens = AntGrid.useBreakpoint();
  const isDesktop = !!screens.md;

  if (!responsive || isDesktop) {
    return (
      <tr
        ref={ref}
        onDoubleClick={onDoubleClick}
        onClick={onClick}
        className={`my-4 min-h-[96px] w-full overflow-hidden rounded-md bg-gray-100 ${className || ''}`}
      >
        {children}
      </tr>
    );
  }

  return (
    <Row
      ref={ref}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      justify='start'
      className={`my-4 w-full overflow-hidden rounded-md bg-gray-100 px-4 ${className || ''}`}
    >
      {children}
    </Row>
  );
});

export default MyTableRow;
